module.exports = __webpack_public_path__ + "static/media/bobaparrot.328aaea5.gif";